import React from 'react';
import { trackPixelEvent } from './MetaPixel';
export const scrollToPricing = () => {
  trackPixelEvent('InitiateCheckout');
  const element = document.getElementById('comprar');
  if (element) {
    element.scrollIntoView({
      behavior: 'smooth'
    });
  }
};
export function CtaButton({
  children,
  onClick,
  className = '',
  href
}: {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  href?: string;
}) {
  const baseClasses = 'inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white bg-gold rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 w-full sm:w-auto text-center';
  if (href) {
    return <a href={href} target="_blank" rel="noopener noreferrer" className={`${baseClasses} ${className}`} onClick={() => trackPixelEvent('InitiateCheckout')} data-id="element-172">
        {children}
      </a>;
  }
  return <button onClick={onClick || scrollToPricing} className={`${baseClasses} ${className}`} data-id="element-173">
      {children}
    </button>;
}
export function SectionHeading({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <h2 className={`font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-navy text-center mb-12 leading-tight ${className}`} data-id="element-174">
      {children}
    </h2>;
}